import { render, staticRenderFns } from "./RedirecionamentoNota.vue?vue&type=template&id=1b941d2c&scoped=true"
import script from "./RedirecionamentoNota.vue?vue&type=script&lang=js"
export * from "./RedirecionamentoNota.vue?vue&type=script&lang=js"
import style0 from "./RedirecionamentoNota.vue?vue&type=style&index=0&id=1b941d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b941d2c",
  null
  
)

export default component.exports